import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

export type BugReportOrigin = 'tab' | 'menu' | 'shortcut'

/**
 * Canal para pedir que se abra el reporte de un problema desde cualquier parte del panel.
 *
 * Existe porque los dos accesos viven en componentes hermanos: la lengüeta se monta en el shell y
 * el ítem «Reportar un problema» está en el menú del avatar, dentro del encabezado. Sin este canal,
 * el encabezado tendría que emitir hacia arriba y el shell reenviar hacia abajo, acoplando dos
 * piezas que no tienen por qué conocerse.
 */
@Injectable({ providedIn: 'root' })
export class BugReportLauncherService {
  private readonly requests = new Subject<BugReportOrigin>()

  /** Lo escucha la lengüeta, que es la dueña del diálogo. */
  readonly requests$ = this.requests.asObservable()

  open(origin: BugReportOrigin = 'menu'): void {
    this.requests.next(origin)
  }
}
